<div
  class="cursor-pointer flex flex-row justify-between flex-row-reverse rounded-02 gap-[8px] meeting-event-code-field grayscale-bg-color"
  [ngClass]="{
    '!border-stroke-01 !border': !errorMessage,
    '!border-[2px] !border-stroke-alert': errorMessage,
    'bg-[#fff]': !disabled,
    'bg-[#f2f3f5]': disabled
  }"
>
  <div class="self-center mr-[16px]">
    <idp-info-tooltip-mach-core
      [infoModalContent]="infoModalContent"
      [tooltipOptions]="tooltipOptions"
    ></idp-info-tooltip-mach-core>
  </div>
  <div class="relative">
    <input
      class="meeting-code-input single-line-input peer !border-0 !shadow-none"
      id="meeting-code-input"
      [value]="value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [idpErrorState]="!!errorMessage"
      [attr.aria-invalid]="!!errorMessage"
      (change)="valueChange.emit($event)"
      autocomplete="off"
      [maxLength]="5"
    />
    <label for="meeting-code-input" class="static-title">
      {{ title }}
    </label>
  </div>
</div>

<ng-container *ngIf="errorMessage">
  <span class="meeting-event-code-field-error text-caption-medium text-alert">
    {{ errorMessage }}
  </span>
</ng-container>
<ng-container *ngIf="disclaimerMessage">
  <div
    class="meeting-event-code-field-disclaimer text-caption-medium w-full laptop:max-w-[278px] mt-[5px]"
    [innerHTML]="disclaimerMessage"
  ></div>
</ng-container>
